import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme: MuiTheme) => {
  const { common, text } = theme.palette;

  return {
    paperWrapper: {
      display: "flex",
      marginBottom: 16,
      padding: "10px 8px 10px 16px",
      alignItems: "center",
      justifyContent: "space-between"
    },
    unselectButton: {
      color: "#333333",
      width: 32,
      height: 32
    },
    listItemWrapper: {
      padding: "8px 16px",
      background: common.white,
      borderBottom: "1px solid #d7d7d7",
      borderRadius: 0,
      height: 80,
      width: "100%",
      lineHeight: "20px",
      alignItems: "start",
      "&:hover": {
        background: common.white
      },
      "& .MuiButton-label": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textTransform: "none"
      },
      "&:nth-child(odd)": {
        background: "#fafafa",
        "&:hover": {
          background: "#fafafa"
        }
      }
    },
    selectedListItem: {
      background: "#eff9f5",
      "&:hover": {
        background: "#e7f3ee"
      },
      "&:nth-child(odd)": {
        background: "#eff9f5",
        "&:hover": {
          background: "#e7f3ee"
        }
      }
    },
    itemInfo: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start"
    },
    itemName: {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      color: text.primary,
      "&.disabled": {
        color: text.disabled
      }
    },
    content: {
      color: text.secondary
    }
  };
});
